import axios from 'axios'
import * as actions from '../../actionTypes'

const GET_CURRENT_TRANSACTION = 'GET_CURRENT_TRANSACTION'
const GET_CURRENT_TRANSACTION_SUCCESS = 'GET_CURRENT_TRANSACTION_SUCCESS'
const GET_CURRENT_TRANSACTION_FAILURE = 'GET_CURRENT_TRANSACTION_FAILURE'

const baseURL = process.env.REACT_APP_SERVICE_URL
const timeout = process.env.REACT_APP_AXIOS_TIME_OUT

const initialState = {
  fullFillmentStatus: '',
}

const instance = axios.create({
  timeout: parseInt(timeout),
})

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_TRANSACTION_SUCCESS:
      return {
        ...state,
        fullFillmentStatus: action.payload.fullFillmentStatus,
      }
    case GET_CURRENT_TRANSACTION:
    case GET_CURRENT_TRANSACTION_FAILURE: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default:
      return state
  }
}

export const getTransactionAction = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_TRANSACTION })
    return instance.get(`${baseURL}services/transactionservice/api/business-transactions/${id}`).then(
      (response) => {
        if (response.status === 200) {
          let fulfillmentStatus = response['data']['fulfillmentStatus']
          dispatch({
            type: GET_CURRENT_TRANSACTION_SUCCESS,
            payload: {
              fullFillmentStatus: fulfillmentStatus,
            },
          })
          return response
        } else {
          dispatch({ type: GET_CURRENT_TRANSACTION_FAILURE })
        }
      },
      (err) => {
        dispatch({ type: GET_CURRENT_TRANSACTION_FAILURE })
        throw new Error(`Error in getting transaction of ${id}`)
      }
    )
  }
}
